import { useForm } from 'react-hook-form'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { authAPI } from '../../api'
import { RiLockLine, RiLoader4Line } from 'react-icons/ri'
import toast from 'react-hot-toast'

export default function ResetPassword() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const token = params.get('token')
  const email = params.get('email')

  const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm()

  const onSubmit = async (data) => {
    try {
      await authAPI.resetPassword({ ...data, token, email })
      toast.success('Password reset successfully!')
      navigate('/login')
    } catch (err) {
      toast.error(err.response?.data?.message || 'Reset failed. Try again.')
    }
  }

  return (
    <div>
      <h1 className="font-display text-salon-dark text-3xl font-bold mb-2">Reset Password</h1>
      <p className="text-salon-muted font-body text-sm mb-8">Enter your new password below.</p>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
        <div>
          <label className="input-label">New Password</label>
          <div className="relative">
            <RiLockLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input {...register('password', { required: true, minLength: 8 })}
              className="input-field pl-10" type="password" placeholder="Min. 8 characters" />
          </div>
        </div>
        <div>
          <label className="input-label">Confirm New Password</label>
          <div className="relative">
            <RiLockLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-salon-muted" />
            <input {...register('password_confirmation', {
              required: true,
              validate: (v) => v === watch('password') || 'Passwords must match',
            })}
              className="input-field pl-10" type="password" placeholder="Confirm password" />
          </div>
          {errors.password_confirmation && <p className="text-red-500 text-xs mt-1">{errors.password_confirmation.message}</p>}
        </div>
        <button type="submit" disabled={isSubmitting} className="btn-primary w-full justify-center">
          {isSubmitting ? <><RiLoader4Line className="animate-spin" /> Resetting...</> : 'Reset Password'}
        </button>
      </form>
    </div>
  )
}
